"use client";
import Cookies from "js-cookie";
import { getEnv } from "@/env";

const isUserLoggedIn = () =>
  !!Cookies.get(getEnv("NEXT_PUBLIC_ACCESS_TOKEN_COOKIE_NAME")) &&
  !!Cookies.get(getEnv("NEXT_PUBLIC_USER_INFO_COOKIE_NAME"));

export default isUserLoggedIn;
